import React from 'react';
import { PropTypes } from 'prop-types';

const FormColumn = ({ children, className }) => (
  <div className={`${className} flex-1`}>
    {children}
  </div>
);

FormColumn.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

FormColumn.defaultProps = {
  className: '',
}

export default FormColumn;
